/* ADORINSE — shared interactions (Shopify)
   nav state · scroll reveal · parallax · count-up · AJAX cart · predictive search */
(function () {
  'use strict';

  var money = window.AD && window.AD.moneyFormat ? window.AD.moneyFormat : '${{amount}}';
  function formatMoney(cents) {
    var value = cents / 100;
    return money.replace(/\{\{\s*amount\s*\}\}/g, value.toFixed(2))
                .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value).toString())
                .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.toFixed(2).replace('.', ','));
  }
  if (window.AD) { window.AD.format = formatMoney; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* ---------- header scrolled state ---------- */
  var header = document.querySelector('.site-header');
  function navScroll() {
    if (!header) return;
    if (window.scrollY > 24) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  }
  navScroll();
  window.addEventListener('scroll', navScroll, { passive: true });

  /* ---------- scroll reveal (probe transition support, then rect-based) ---------- */
  var reveals = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  function runReveal() {
    var pending = reveals.slice();
    var revealCheck = function () {
      if (!pending.length) return;
      var vh = window.innerHeight;
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) { el.classList.add('in'); return false; }
        return true;
      });
    };
    revealCheck();
    window.addEventListener('scroll', revealCheck, { passive: true });
    window.addEventListener('resize', revealCheck, { passive: true });
    setTimeout(function () { reveals.forEach(function (el) { el.classList.add('in'); }); }, 3000);
  }
  if (!reduce && reveals.length) {
    root.classList.add('reveal-init');
    var probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;left:-9999px;top:0;width:4px;height:4px;opacity:0;transition:opacity .3s linear;';
    document.body.appendChild(probe);
    void probe.offsetWidth;
    probe.style.opacity = '1';
    setTimeout(function () {
      var op = parseFloat(getComputedStyle(probe).opacity);
      probe.remove();
      if (op > 0.02) { runReveal(); }
      else { root.classList.remove('reveal-init'); }  // frozen context — show everything
    }, 130);
  }

  /* ---------- parallax (hero product, float chips, scene bg) ---------- */
  var heroProduct = document.querySelector('[data-parallax-product]');
  var chips = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-chip]'));
  var sceneBg = document.querySelector('[data-parallax-scene]');
  var sceneEl = sceneBg ? sceneBg.closest('.scene') : null;
  var ticking = false;
  function parallax() {
    var y = window.scrollY;
    if (heroProduct) heroProduct.style.transform = 'translateY(' + (y * 0.06) + 'px)';
    chips.forEach(function (c, i) {
      var speed = [0.12, -0.1, 0.16][i % 3];
      c.style.transform = 'translateY(' + (y * speed) + 'px)';
    });
    if (sceneBg && sceneEl) {
      var rect = sceneEl.getBoundingClientRect();
      var vh = window.innerHeight;
      if (rect.bottom > 0 && rect.top < vh) {
        var progress = (vh - rect.top) / (vh + rect.height);
        var shift = (progress - 0.5) * 80;
        sceneBg.style.transform = 'translateY(' + shift + 'px) scale(1.12)';
      }
    }
    ticking = false;
  }
  if (!reduce && (heroProduct || chips.length || sceneBg)) {
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(parallax); }
    }, { passive: true });
    parallax();
  }

  /* ---------- animated stat count-up (rect-based) ---------- */
  var counters = Array.prototype.slice.call(document.querySelectorAll('[data-count]'));
  function fmtN(v, dec) { return dec ? v.toFixed(dec) : Math.round(v).toString(); }
  function runCount(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var target = parseFloat(el.dataset.count);
    var dec = (el.dataset.count.split('.')[1] || '').length;
    if (reduce) { el.textContent = fmtN(target, dec); return; }
    var dur = 1400, start = performance.now();
    (function step(now) {
      var p = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmtN(target * eased, dec);
      if (p < 1) requestAnimationFrame(step);
    })(performance.now());
  }
  if (counters.length) {
    var countCheck = function () {
      var vh = window.innerHeight;
      counters.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.85 && r.bottom > 0) runCount(el);
      });
    };
    countCheck();
    window.addEventListener('scroll', countCheck, { passive: true });
    setTimeout(function () { counters.forEach(runCount); }, 2800);
  }

  /* ---------- mobile drawer ---------- */
  var burgers = document.querySelectorAll('[data-burger]');
  var drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    burgers.forEach(function (b) {
      b.addEventListener('click', function () { drawer.classList.toggle('open'); document.body.classList.toggle('no-scroll'); });
    });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { drawer.classList.remove('open'); document.body.classList.remove('no-scroll'); }); });
  }

  /* ---------- cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  function openCart() { if (cartDrawer) { cartDrawer.classList.add('open'); cartOverlay.classList.add('open'); document.body.classList.add('no-scroll'); } }
  function closeCart() { if (cartDrawer) { cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); document.body.classList.remove('no-scroll'); } }
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { if (cartDrawer) { e.preventDefault(); openCart(); } });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
  if (cartOverlay) { cartOverlay.addEventListener('click', closeCart); }
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') { closeCart(); closeSearch(); } });

  function paintCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('show', n > 0);
    });
  }

  function renderDrawer(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-foot]');
    if (!body) return;
    paintCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty flow"><p class="eyebrow">Empty</p><p class="lede">Your cart is quiet for now.</p><a href="/collections/all" class="btn btn-primary" data-cart-close>Shop the range</a></div>';
      if (foot) foot.style.display = 'none';
      body.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[^.]+)($|\?)/, '_160x$1$2') + '" alt="' + it.product_title + '">' : '';
      var variant = (it.product_has_only_default_variant ? '' : it.variant_title) || '';
      return '<div class="mini-line">' +
        '<a href="' + it.url + '" class="ph ph--celadon mini-line__media">' + img + '</a>' +
        '<div><div class="mini-line__name">' + it.product_title + '</div>' +
        (variant ? '<div class="mini-line__var">' + variant + '</div>' : '') +
        '<div class="qty" style="margin-top:10px"><button data-line-dec="' + it.key + '" aria-label="Decrease">–</button><span>' + it.quantity + '</span><button data-line-inc="' + it.key + '" aria-label="Increase">+</button></div>' +
        '<button class="mini-line__rm" data-line-remove="' + it.key + '">Remove</button></div>' +
        '<div class="mini-line__price">' + formatMoney(it.final_line_price) + '</div>' +
      '</div>';
    }).join('');
    if (foot) {
      var subEl = foot.querySelector('[data-cart-subtotal]');
      if (subEl) subEl.textContent = formatMoney(cart.total_price);
      var bar = foot.querySelector('[data-cart-progress]');
      var msg = foot.querySelector('[data-cart-ship-msg]');
      var threshold = window.AD && window.AD.freeShip ? window.AD.freeShip : 0;
      if (bar && threshold) {
        var pct = Math.min(1, cart.total_price / threshold);
        bar.style.transform = 'scaleX(' + pct + ')';
        var left = threshold - cart.total_price;
        msg.innerHTML = cart.total_price >= threshold ? "You've earned <b>free shipping</b>." : '<b>' + formatMoney(left) + '</b> away from free shipping.';
      }
    }
    bindDrawerLines();
  }
  function bindDrawerLines() {
    document.querySelectorAll('[data-line-remove]').forEach(function (b) { b.onclick = function () { changeLine(b.getAttribute('data-line-remove'), 0); }; });
    document.querySelectorAll('[data-line-inc]').forEach(function (b) { b.onclick = function () { adjustLine(b.getAttribute('data-line-inc'), 1); }; });
    document.querySelectorAll('[data-line-dec]').forEach(function (b) { b.onclick = function () { adjustLine(b.getAttribute('data-line-dec'), -1); }; });
  }
  function adjustLine(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var it = cart.items.filter(function (i) { return i.key === key; })[0];
      if (it) changeLine(key, Math.max(0, it.quantity + delta));
    });
  }
  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    });
  }
  window.adRefreshCart = function () { fetch('/cart.js').then(function (r) { return r.json(); }).then(renderDrawer); };

  /* ---------- add to cart (AJAX) ---------- */
  document.querySelectorAll('form[action$="/cart/add"], form[data-add-form]').forEach(function (form) {
    if (form.__bound) return; form.__bound = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var orig = btn ? btn.innerHTML : '';
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.innerHTML = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = orig; }
          if (!res.ok) { showToast(res.d.description || 'Could not add to cart'); return; }
          window.adRefreshCart();
          openCart();
          document.dispatchEvent(new CustomEvent('cart:added', { detail: res.d }));
        })
        .catch(function () { if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = orig; } });
    });
  });

  /* ---------- toast ---------- */
  var toast = document.querySelector('[data-toast]');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (msg) { toast.childNodes[0].nodeValue = msg + ' '; }
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3200);
  }
  window.adToast = showToast;

  /* ---------- predictive search ---------- */
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchInput = searchPanel ? searchPanel.querySelector('input[type=search]') : null;
  var searchResults = searchPanel ? searchPanel.querySelector('[data-search-results]') : null;
  function openSearch() { if (searchPanel) { searchPanel.classList.add('open'); document.body.classList.add('no-scroll'); if (searchInput) searchInput.focus(); } }
  function closeSearch() { if (searchPanel) { searchPanel.classList.remove('open'); document.body.classList.remove('no-scroll'); } }
  document.querySelectorAll('[data-search-open]').forEach(function (el) { el.addEventListener('click', function (e) { if (searchPanel) { e.preventDefault(); openSearch(); } }); });
  document.querySelectorAll('[data-search-close]').forEach(function (el) { el.addEventListener('click', closeSearch); });
  var searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources.results.products) || [];
            if (!products.length) { searchResults.innerHTML = '<p class="body">No matches for &ldquo;' + q + '&rdquo; yet.</p>'; return; }
            searchResults.innerHTML = '<div class="prod-grid cols-4">' + products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="' + p.title + '">' : '';
              return '<a href="' + p.url + '" class="card"><div class="ph ph--celadon card__media">' + img + '</div><div class="card__name" style="font-size:1.15rem">' + p.title + '</div><div class="card__price" style="margin-top:6px">' + p.price + '</div></a>';
            }).join('') + '</div>';
          });
      }, 220);
    });
  }
  window.adCloseSearch = closeSearch;

  // initial paint
  window.adRefreshCart();
})();
